import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-11.jpg";
import aiImg from "../../assets/img/ai-WISvision.png";
import aiIcon01 from "../../assets/img/icon-ai24.png";
import aiIcon02 from "../../assets/img/icon-ai26.png";
import aiIcon03 from "../../assets/img/icon-ai27.png";
import aiIcon04 from "../../assets/img/icon-ai23.png";
import fwImg from "../../assets/img/fw-wisvision.png";

function WISplatform() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';


   //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISvision 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
  
    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">이미지 영상 분석 솔루션</span>
						<h2>WISvision</h2>
						<p>정확하고 빠른 객체 탐지, 행동 분석, 이상감지까지 비즈니스에 필요한 모든 비전 AI 기능을 제공합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISvision 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISvision" /></div>
            <div className="info">
              <p>딥러닝 기반의 영상·이미지 분석 AI 솔루션으로, 각종 영상 소스에서 주요 객체(사람, 차량, 동물 등)를 실시간 탐지, 추적, 분석하며, 다양한 산업(보안, 제조, 교통, 환경 등)에서 자동화 및 안전 강화를 실현합니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">객체 탐지 및 분류</p>
                  <p className="txt">사람, 차량, 동물 등 다양한 유형 객체 탐지와 카테고리 분류(성별, 옷 색상, 차종, 번호판 등 세부 분류) </p>
                </li>
                 <li>
                  <p className="tit">객체 추적 및 행동 분석</p>
                  <p className="txt">특정 객체의 위치 및 이동 경로 추적, 군집·배회·침입·상태 등 특이 이벤트 감지(통제, 안전 관리, 침입 감시 등) </p>
                </li>
                 <li>
                  <p className="tit">고속 영상 검색</p>
                  <p className="txt">대용량 영상 내 특정 객체·이벤트 고속 검색(수 시간 분량도 수분 내 처리) </p>
                </li>
                 <li>
                  <p className="tit">비식별화 및 영상 정보보안</p>
                  <p className="txt">민감정보(얼굴 등) 마스킹, 암호화, DRM 적용, 개인정보 보호 준수 </p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="딥러닝 기반 객체 인식/추적"/></span>
              <p className="tit">딥러닝 기반<br/>객체 인식/추적</p>
              <p className="txt">YOLO, Re-ID(재식별), CNN 등 첨단 알고리즘 적용, 정밀한 탐지 및 식별</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="고성능 GPU 경량화 모델"/></span>
              <p className="tit">고성능 GPU<br/>경량화 모델</p>
              <p className="txt">고화질(4K/8K, 120FPS), 대용량 실시간 분석이 가능하면서도, Edge 단 경량화로 현장 적용 용이</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="이벤트 기반 자동 알림과 통계"/></span>
              <p className="tit">이벤트 기반<br/>자동 알림과 통계</p>
              <p className="txt">상황별 이벤트 (사고, 위험군, 이상행동 등) 알림 및 이력 통계 분석</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="클라우드/온프레미스 모두 지원"/></span>
              <p className="tit">클라우드/온프레미스<br/> 모두 지원</p>
              <p className="txt">다양한 현장 환경 (관제센터, 산업 현장,의료, 환경 등)에서 적용 가능</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">영상소스</p>
                <p className="txt">이미지/영상</p>
              </li>
              <li>
                <p className="tit">전처리</p>
                <p className="txt">압축 해제/화질 보정</p>
              </li>
              <li>
                <p className="tit">딥러닝</p>
                <p className="txt">객체 탐지/분류 엔진</p>
              </li>
              <li>
                <p className="tit">분석</p>
                <p className="txt">행동/이벤트감지</p>
              </li>
              <li>
                <p className="tit">데이터저장</p>
                <p className="txt">마스킹/암호화/DRM</p>
              </li>
              <li>
                <p className="tit">실시간알림</p>
                <p className="txt">관리 대시보드/외부 시스템 연동</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework"  onClick={imgClick}>
              <img src={fwImg} alt="WISvision 프레임워크"/>
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>MLOps 파이프라인</span>
          </h4>
          <div className="list-wrap">
            <ul className="textWrap ac-list2">
              <li>
                <p className="tit">데이터 구축</p>
                <ul className="txt">
                  <li>프로젝트별 데이터 구축</li>
                </ul>
              </li>
              <li>
                <p className="tit">전처리</p>
                <ul className="txt">
                  <li>중복이미지 검사</li>
                  <li>이미지 증강</li>
                </ul>
              </li>
              <li>
                <p className="tit">라벨링</p>
                <ul className="txt">
                  <li>다중 이용자 대응</li>
                  <li>고용량 이미지 라벨링을 위한 C/S환경 툴 제공</li>
                  <li>오토라벨링 지원</li>
                </ul>
                <p className="info-txt">오토 라벨링</p>
              </li>
              <li>
                <p className="tit">학습</p>
                <ul className="txt">
                  <li>최신 알고리즘 지원</li>
                  <li>프로젝트별 모델관리 지원</li>
                  <li>학습 결과를 이용한 오토라벨링 지원</li>
                </ul>
              </li>
              <li>
                <p className="tit">모델 배포</p>
                <ul className="txt">
                  <li>하나의 파이프라인으로 데이터 구축과 학습에서 배포까지 일괄 지원</li>
                </ul>
              </li>
            </ul>

            
          </div>
            
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">보안&관제</p>
                <p className="txt">침입·폭력·쓰러짐 등 이상행위 자동 감지, CCTV 동시 분석 및 관제센터 연동</p>
              </li>
                <li>
                <p className="tit">교통/시설관리 </p>
                <p className="txt">차종/번호판 인식, 군집/대기열/돌발상황 감지</p>
              </li>
                <li>
                <p className="tit">산업/의료</p>
                <p className="txt">작업자 안전 관리, 수술실 내 영상 보안, 작업장 이상행동 모니터링</p>
              </li>
                <li>
                <p className="tit">데이터 프라이버시</p>
                <p className="txt">의료, 기업, 공공분야 맞춤 비식별화 처리</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISplatform;